// This is the parent component of a modal: ModalReferralstwo

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CalendarstarIcon,
  CellsIcon,
  DivideSignIcon,
  InfoCircleIcon,
  LayoutIcon,
  LocationIcon,
  PinIcon,
  PoundIcon,
  SearchListIcon,
} from "./assets";
import GenericModal from "./GenericModal";
import ModalReferralstwo from "./ModalReferralstwo";
import ShareVendorModal from "./ShareVendorModal";
import BadgeWrapper from "./prtnr/ui/BadgeType";
import {
  fetchVendorById,
  fetchVendorItems,
  fetchVendorsBySector,
} from "./redux/slices/VendorThunks";
import Navbar from "./shared/Navbar";
import { generateSlugMap, scrollToTop } from "./utils/func";
import VideoPlayer from "./prtnr/ui/VideoPlayer";
import { trackVendorPageViewed } from "./utils/analytics";

const generateSlugFromVendor = (vendor) => {
  return vendor?.company_name.toLowerCase().replace(/\s+/g, "-");
};

const asRichText = (value) => ({
  __html: value || "",
});

export default function Referralstwo() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const location = useLocation();
  const [vendor, setVendor] = useState(location.state?.vendor);
  const { user, loading, hasChecked } = useSelector((state) => state.auth);

  const vendors = useSelector((state) => state.vendor.items);
  // const vendor = useSelector((state) => state.vendor?.selectedVendor);
  const relatedVendors = useSelector((state) => state.vendor?.vendorsBySector);
  const dispatch = useDispatch();
  const member = JSON.parse(localStorage.getItem("member"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const openShareModal = () => setIsShareModalOpen(true);
  const closeShareModal = () => setIsShareModalOpen(false);

  const filteredRelatedVendors =
    relatedVendors?.length > 0 && vendor?.vendor_industry_sector
      ? relatedVendors
          .filter(
            (v) =>
              v._id !== vendor._id &&
              !["Freeze", "Draft"].includes(v.vendor_profile_status) &&
              v.vendor_industry_sector === vendor.vendor_industry_sector
          )
          .slice(0, 4)
      : [];

  useEffect(
    () => {
      if (vendors.length === 0) {
        dispatch(fetchVendorItems());
      }
    },
    [dispatch, vendors.length],
    slug
  );

  useEffect(() => {
    const fetchVendor = async () => {
      if (vendors.length > 0 && slug) {
        const slugMap = generateSlugMap(vendors);
        const id = slugMap[slug];
        if (id) {
          try {
            const res = await dispatch(fetchVendorById(id)).unwrap();
            setVendor(res);
          } catch (error) {
            console.error("Failed to fetch vendor:", error);
          }
        }
      }
    };

    fetchVendor();
  }, [slug, vendors, dispatch]);

  useEffect(() => {
    if (vendor?.vendor_industry_sector) {
      dispatch(fetchVendorsBySector(vendor.vendor_industry_sector));
    }
  }, [vendor?.vendor_industry_sector, dispatch, slug]);

  useEffect(() => {
    if (vendor?.vendor_profile_status === "Freeze") {
      navigate("/vendors");
    }
  }, [vendor, navigate]);

  useEffect(() => {
  if (!vendor?._id) return;

  trackVendorPageViewed(vendor?._id, vendor?.company_name);
}, [vendor]);

  const handleShare = () => {
    openShareModal();
  };

  return (
    <>
      <Navbar />
      <RootWrapperReferralstwo>
        <Section>
          <Wrapper>
            <Breadcrumbs>
              <Frame74>
                <Frame71>
                  <Heart
                    src="https://d3nakrlcog1u3z.cloudfront.net/1751292377234-Heart.svg"
                    alt="icon"
                  />
                  <DataInsight>{vendor?.vendor_industry_sector}</DataInsight>
                </Frame71>
                <Frame71>
                  <Heart_0001 xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill="rgb(100, 116, 139)"
                      d="M7.29688 6.20312C7.57812 6.51562 7.57812 6.98438 7.29688 7.26562L1.29688 13.2656C0.984375 13.5781 0.515625 13.5781 0.234375 13.2656C-0.078125 12.9844 -0.078125 12.5156 0.234375 12.2344L5.70312 6.76562L0.234375 1.26562C-0.078125 0.984375 -0.078125 0.515625 0.234375 0.234375C0.515625 -0.078125 0.984375 -0.078125 1.26562 0.234375L7.29688 6.20312Z"
                    />
                  </Heart_0001>
                  <Nesti>{vendor?.company_name}</Nesti>
                </Frame71>
              </Frame74>
            </Breadcrumbs>
          </Wrapper>
        </Section>
        <VendorProfileDetails>
          <Wrapper>
            <Row>
              <Col1>
                <Frame1389>
                  <Image20 src={vendor?.website_thumbnail} />
                </Frame1389>
                <Frame77>
                  <Logo_0001>
                    <BadgeWrapper badgeType={vendor?.vendor_badge} />

                    <ImageLogo
                      src={`${vendor?.compay_logo}`}
                      alt="Company Logo"
                    />
                  </Logo_0001>
                  <Frame76B>
                    <Frame1542 />
                    <Frame1543>
                      <Reward>Reward</Reward>
                      <_900> £{vendor?.reward}</_900>
                      <FixedReferralReward_0001>
                        Fixed Referral Reward
                      </FixedReferralReward_0001>

                      <AIMEButton
                        size="small"
                        onClick={() => {
                          if (user) {
                            openModal();
                          } else {
                            window.location.href =
                              process.env.REACT_APP_AUTH_BASE_URL;
                          }
                        }}
                        disabled={member?.profile_status === "Freeze"}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: "8px",
                          borderRadius: "999px",
                          alignSelf: "stretch",
                          height: "50px",
                          background: "rgb(97, 98, 197)",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                          backgroundPosition: "center",
                          boxSizing: "border-box",
                          padding: "16px 32px",
                          flexShrink: "0",
                          opacity:
                            member?.profile_status === "Freeze" ? 0.9 : 1,
                          pointerEvents:
                            member?.profile_status === "Freeze"
                              ? "none"
                              : "auto",
                          "&:hover": {
                            background: "rgb(97, 98, 197)",
                            opacity: "0.9",
                          },
                        }}
                      >
                        <span
                          style={{
                            color: "white",
                            textOverflow: "ellipsis",
                            fontSize: "16px",
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: "600",
                            lineHeight: "110%",
                            textAlign: "left",
                          }}
                        >
                          {member?.profile_status === "Freeze"
                            ? "Currently Unavailable"
                            : "Submit Referral"}
                        </span>
                      </AIMEButton>
                    </Frame1543>
                  </Frame76B>
                  <Frame78>
                    <Row_0001>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <Nesti_0001>{vendor?.company_name}</Nesti_0001>
                        <ShareButton onClick={handleShare}>
                          {ShareIcon}
                        </ShareButton>
                      </div>
                      <AiVideoProspecting>
                        {vendor?.short_description}
                      </AiVideoProspecting>
                    </Row_0001>
                    <Frame86>
                      <Row_0002>
                        <Frame82>
                          <Type>Type:</Type>
                          <FixedReferralReward>
                            Fixed Referral Reward
                          </FixedReferralReward>
                        </Frame82>
                      </Row_0002>
                      <Row_0003>
                        <Frame82>
                          <Website>Website:</Website>
                          <HttpsNestiIo>
                            {" "}
                            {vendor?.company_website_url}
                          </HttpsNestiIo>
                        </Frame82>
                      </Row_0003>
                    </Frame86>
                  </Frame78>
                </Frame77>
                <Frame85>
                  <AboutCompany>About Company</AboutCompany>
                  <Addinfo>
                    <AdditionalInfo>
                      <NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale
                        dangerouslySetInnerHTML={asRichText(vendor?.about)}
                        className="quill-content"
                      />
                    </AdditionalInfo>
                  </Addinfo>
                </Frame85>
                {vendor?.trusted_by && vendor?.trusted_by.length > 0 && (
                  <Frame85>
                    <TrustedFrame>
                      <CeoMessage>Trusted By</CeoMessage>

                      {/* <TrustedTitle>Trusted By</TrustedTitle> */}
                      <TrustedByContainer>
                        {vendor.trusted_by.map((logoUrl, index) => (
                          <TrustedByLogoWrapper key={index}>
                            <TrustedByLogo
                              src={logoUrl}
                              alt={`Trusted company ${index + 1}`}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </TrustedByLogoWrapper>
                        ))}
                      </TrustedByContainer>
                    </TrustedFrame>
                  </Frame85>
                )}
                <Frame85>
                  <T>
                    <IdealClientProfile>
                      Ideal Client Profile
                    </IdealClientProfile>
                    <Addinfo>
                      <AdditionalInfo>
                        <NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale
                          dangerouslySetInnerHTML={asRichText(
                            vendor?.ideal_profile
                          )}
                          className="quill-content"
                        />
                      </AdditionalInfo>
                    </Addinfo>
                    <Content>
                      <_1>
                        <Column1>
                          <Layout01 src={LayoutIcon} alt="icon" />
                          <Sector>Sector</Sector>
                        </Column1>
                        <OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular>
                          {vendor?.sector}
                        </OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular>
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <Cells src={CellsIcon} alt="icon" />
                          <Sector>Company Size</Sector>
                        </Column1>
                        <_150000
                          dangerouslySetInnerHTML={asRichText(
                            vendor?.company_size
                          )}
                          className="quill-content"
                        />
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <Location01 src={LocationIcon} alt="icon" />
                          <Sector>Location</Sector>
                        </Column1>
                        <UkUsa> {vendor?.locations}</UkUsa>
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <Pound src={PoundIcon} alt="icon" />
                          <Sector>Typical Budget</Sector>
                        </Column1>
                        <_150000
                          dangerouslySetInnerHTML={asRichText(
                            vendor?.typical_budget
                          )}
                          className="quill-content"
                        />
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1_0004>
                          <DivideSign src={DivideSignIcon} alt="icon" />
                          <Sector>Typical Decision Maker</Sector>
                        </Column1_0004>
                        <HeadsOfMarketingHeadsOfSales>
                          {vendor?.typical_decision_maker}
                        </HeadsOfMarketingHeadsOfSales>
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <SearchList01 src={SearchListIcon} alt="icon" />
                          <Sector>Typical Scenario</Sector>
                        </Column1>
                        <WeTypicallyHelpOurClientsWithProspectingNewClientsAndIncreasingSalesPipeline
                          dangerouslySetInnerHTML={asRichText(
                            vendor?.typical_scenario
                          )}
                          className="quill-content"
                        />
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <Pin src={PinIcon} alt="icon" />
                          <Sector>Typical Pain Points</Sector>
                        </Column1>
                        <OurClientsTypicallyDesireNewToolsToHelpThemGenerateSalesPipelineAndReachTheirProspectsInInnovativeInteractiveAndPersonalisedWays
                          dangerouslySetInnerHTML={asRichText(
                            vendor?.typical_pain_points
                          )}
                          className="quill-content"
                        />
                      </_1>
                      <Contentdivider>
                        <Line1 />
                      </Contentdivider>
                      <_1>
                        <Column1>
                          <Pin src={CalendarstarIcon} alt="icon" />
                          <TypicalDealCycle>
                            Typical deal cycle
                          </TypicalDealCycle>
                          <TooltipWrapper>
                            <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                            <TooltipText className="tooltip">
                              Length of average deal cycle, from first contact
                              to contract signing
                            </TooltipText>
                          </TooltipWrapper>
                        </Column1>
                        <_2Months>
                          {" "}
                          {vendor?.average_sales_cycle_in_months}
                        </_2Months>
                      </_1>
                    </Content>
                  </T>
                </Frame85>
                <Frame85>
                  <CeoMessage>Vendor Message to Members</CeoMessage>
                  <Testimonialmain>
                    <Body>
                      <NestiHelpsDemandGenerationTeamsCreateTrulyPersonalisedDigitalExperiencesAtScaleThatGenerateWarmLeadsForSalesInsteadOfGenericOutreachYouCanNowDeliverTrulyPersonalisedVideoExperiencesForEveryProspectWeDLoveYouToMakeAReferralToUsViaPartnerAndWeLlPromiseToRollOutTheRedCarpetForYourFriendEnsuringAGreatClientExperience
                        dangerouslySetInnerHTML={asRichText(
                          `${vendor?.message}`
                        )}
                        className="quill-content"
                      />
                    </Body>
                    <Namewithavatar>
                      <img
                        src={vendor?.picture}
                        alt="Profile"
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "32px",
                          objectFit: "cover",
                        }}
                      />
                      <Top>
                        <MorganEdmondson ndson>
                          {" "}
                          {vendor?.ceo_name}
                        </MorganEdmondson>
                      </Top>
                    </Namewithavatar>
                  </Testimonialmain>
                </Frame85>
              </Col1>
              <Col2>
                <Frame76>
                  <Frame1542 />
                  <Frame1543>
                    <Reward>Reward</Reward>
                    <_900>
                      {" "}
                      £{Number(vendor?.reward)?.toLocaleString("en-GB")}
                    </_900>
                    <FixedReferralReward_0001>
                      Fixed Referral Reward
                    </FixedReferralReward_0001>

                    <AIMEButton
                      size="small"
                      onClick={() => {
                        if (user) {
                          openModal();
                        } else {
                          window.location.href =
                            process.env.REACT_APP_AUTH_BASE_URL;
                        }
                      }}
                      disabled={member?.profile_status === "Freeze"}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                        borderRadius: "999px",
                        alignSelf: "stretch",
                        height: "50px",
                        background: "rgb(97, 98, 197)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        boxSizing: "border-box",
                        padding: "16px 32px",
                        flexShrink: "0",
                        opacity: member?.profile_status === "Freeze" ? 0.9 : 1,
                        pointerEvents:
                          member?.profile_status === "Freeze" ? "none" : "auto",
                        "&:hover": {
                          background: "rgb(97, 98, 197)",
                          opacity: "0.9",
                        },
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          textOverflow: "ellipsis",
                          fontSize: "16px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "110%",
                          textAlign: "left",
                        }}
                      >
                        {member?.profile_status === "Freeze"
                          ? "Currently Unavailable"
                          : "Submit Referral"}
                      </span>
                    </AIMEButton>
                  </Frame1543>
                </Frame76>
                <Faqs>
                  <WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned>
                    When will I get paid my Fixed Referral Reward?
                    <br />
                    <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                      Typically within 30 days of a vendor successfully signing
                      a contract with the referred client.
                    </span>
                  </WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned>
                  <Contentdivider_0007>
                    <Line1_0007 />
                  </Contentdivider_0007>
                  <HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount>
                    How will I get paid my Fixed Referral Reward?
                    <br />
                    <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                      Rewards can be paid directly into your chosen bank
                      account. Alternatively, you may decide to donate to one of
                      our chosen charities.
                    </span>
                  </HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount>
                  <Contentdivider_0007>
                    <Line1_0007 />
                  </Contentdivider_0007>
                  <TrackedInTypicallyLessThan24Hours>
                    How soon will I be able to see the vendor's progress with my
                    referral?
                    <br />
                    <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                      Typically, less than 24 hours.
                    </span>
                  </TrackedInTypicallyLessThan24Hours>
                </Faqs>
                {vendor?.video_url && (
                  <Frame85>
                    <VideoPlayer videoUrl={vendor?.video_url} />
                    <IntroducingBy>
                      Introducing: {vendor?.company_name}
                    </IntroducingBy>
                  </Frame85>
                )}

                <Frame85>
                  <Addinfo>
                    <AdditionalInfo>
                      <NumberOfEmployees110>
                        Number of Employees: {vendor?.no_of_employees}
                      </NumberOfEmployees110>
                      <Contentdivider_0007>
                        <Line1 />
                      </Contentdivider_0007>
                      <HqBristolUk>HQ: {vendor?.vendor_hq}</HqBristolUk>
                      <Contentdivider_0007>
                        <Line1 />
                      </Contentdivider_0007>
                      <Founded2021>Founded: {vendor?.year_founded}</Founded2021>
                    </AdditionalInfo>
                  </Addinfo>
                </Frame85>
              </Col2>
            </Row>
          </Wrapper>
        </VendorProfileDetails>
        <Section_0001>
          {filteredRelatedVendors.length > 0 && (
            <SectionRelated>
              <Frame51>
                <RelatedVendors>Related Vendors</RelatedVendors>
                {/* <GButtons
                onClick={() => {
                  navigate("/vendors");
                }}
              >
                <ButtonLabel_0005>Read More</ButtonLabel_0005>
              </GButtons> */}
              </Frame51>
              <Frame47>
                <DealCard>
                  <Wrapper_0003>
                    {filteredRelatedVendors.map((v) => {
                      const slug = generateSlugFromVendor(v); // generate slug on the fly

                      return (
                        <DealCardWrapper
                          key={v._id}
                          onClick={() => {
                            navigate(`/vendors/${slug}`, { state: { v } });
                            scrollToTop();
                          }}
                        >
                          <PRTNR.DealCard
                            title={v?.short_description}
                            reward={v?.reward}
                            badgeType={v?.vendor_badge}
                            logoUrl={v?.compay_logo}
                          />
                        </DealCardWrapper>
                      );
                    })}
                  </Wrapper_0003>
                </DealCard>
              </Frame47>
            </SectionRelated>
          )}
        </Section_0001>

        <GenericModal isOpen={isModalOpen} onClose={closeModal}>
          <ModalReferralstwo
            isOpen={isModalOpen}
            onClose={closeModal}
            VendorId={vendor?._id}
          />
        </GenericModal>

        <GenericModal isOpen={isShareModalOpen} onClose={closeShareModal}>
          <ShareVendorModal onClose={closeShareModal} vendor={vendor} />
        </GenericModal>
      </RootWrapperReferralstwo>
    </>
  );
}

const RootWrapperReferralstwo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  padding-top: 89px;

  @media (max-width: 768px) {
    padding-top: 84px;
  }
`;

const Section = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Breadcrumbs = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 12px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 0px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame74 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 12px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame71 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Heart = styled.img`
  width: 14px;
  height: 14px;
  object-fit: cover;
`;

const TrustedFrame = styled.div`
  width: 100%;
`;
const TrustedTitle = styled.div`
  font-size: 25px;
  font-weight: 700;
  font-family: Montserrat, sans-serif;

  padding-bottom: 16px;
`;
const IntroducingBy = styled.div`
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: flex-start;
  font-family: Montserrat, sans-serif;

  width: 100%;
`;
const TrustedBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const TrustedLogo = styled.img`
  width: 160px;
  height: 80px;
  object-fit: contain;
  border: 4px solid rgba(136, 136, 136, 0.1);
`;

const DataInsight = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Heart_0001 = styled.svg`
  width: 8px;
  height: 14px;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
const ShareButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

const ShareIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#64748B"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-share2-icon lucide-share-2"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
  </svg>
);

const VendorProfileDetails = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
  background: rgb(255, 255, 255);
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px 0px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Col1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 32px;
  width: 848px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
const Frame1389 = styled.div`
  max-height: 297px;
  overflow: hidden;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 16px;
  position: relative;
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image20 = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const Frame77 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Logo_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  width: 260px;
  height: 150px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 3.44px;
  position: relative;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
const ImageLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

const Frame78 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  width: 564px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Row_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Nesti_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(24px, 2.5vw, 48px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const AiVideoProspecting = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 582px;
  min-height: 22px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame86 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Row_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-top: solid 1px rgba(136, 136, 136, 0.1);
  border-bottom: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame82 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 532px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Type = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const FixedReferralReward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 489px;
  flex: 1;
`;

const Row_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Website = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const HttpsNestiIo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 462px;
  flex: 1;
`;

const Frame85 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AboutCompany = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Addinfo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px 16px;
  flex-shrink: 0;
`;

const AdditionalInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const T = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IdealClientProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const _1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Column1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  width: 250px;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Layout01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const Sector = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const Contentdivider = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Line1 = styled.div`
  height: 0px;
  border-top: solid 1px rgb(225, 228, 234);
  align-self: stretch;
  flex-shrink: 0;
`;

const Cells = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const _150000 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const Location01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const UkUsa = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const Pound = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const Column1_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  width: 250px;
  height: 24px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const DivideSign = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const HeadsOfMarketingHeadsOfSales = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const SearchList01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const WeTypicallyHelpOurClientsWithProspectingNewClientsAndIncreasingSalesPipeline = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const Pin = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const OurClientsTypicallyDesireNewToolsToHelpThemGenerateSalesPipelineAndReachTheirProspectsInInnovativeInteractiveAndPersonalisedWays = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const TypicalDealCycle = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _2Months = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const CeoMessage = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(16px, 2vw, 20px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const TrustedByContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  align-items: center;
  justify-items: center;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px 24px;
  flex-shrink: 0;

  @media (max-width: 1024px) and (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 24px 16px;
  }
`;

const TrustedByLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  border: solid 1px rgb(225, 228, 234);
  border-radius: 8px;
  padding: 6px;

  @media (max-width: 767px) {
    height: 60px;
    padding: 4px;
  }
`;

const TrustedByLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const Testimonialmain = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-shadow: 0px 3px 2px rgba(132, 38, 232, 0.03);
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Body = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const NestiHelpsDemandGenerationTeamsCreateTrulyPersonalisedDigitalExperiencesAtScaleThatGenerateWarmLeadsForSalesInsteadOfGenericOutreachYouCanNowDeliverTrulyPersonalisedVideoExperiencesForEveryProspectWeDLoveYouToMakeAReferralToUsViaPartnerAndWeLlPromiseToRollOutTheRedCarpetForYourFriendEnsuringAGreatClientExperience = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  font-style: italic;
`;

const Namewithavatar = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Top = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex: 1;
  }

  @media (max-width: 767px) {
    flex: 1;
  }
`;

const MorganEdmondson = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Col2 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  width: 320px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame76 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  align-self: stretch;
  background: radial-gradient(rgb(212, 242, 255), rgb(136, 204, 235));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 0px 32px;
  flex-shrink: 0;
  padding-inline: 23.5px;

  @media (max-width: 1024px) {
    display: none;
  }
`;
const Frame76B = styled.div`
  display: none;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  align-self: stretch;
  background: radial-gradient(rgb(212, 242, 255), rgb(136, 204, 235));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 0px 32px;
  flex-shrink: 0;
  padding-inline: 23.5px;

  @media (max-width: 1024px) {
    display: flex;
    width: 100%;
  }
`;

const Frame1542 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  flex-shrink: 0;
`;

const Frame1543 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 11px;
  width: 273px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const Reward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const _900 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 68px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -2px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const FixedReferralReward_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Faqs = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Contentdivider_0007 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Line1_0007 = styled.div`
  height: 0px;
  border-top: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  flex-shrink: 0;
`;

const HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TrackedInTypicallyLessThan24Hours = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const AverageSalesCycle6Weeks = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const NumberOfEmployees110 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const HqBristolUk = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Founded2021 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 16px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
  padding-block: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  align-self: stretch;
  @media (max-width: 1024px) and (min-width: 768px) {
    padding-inline: clamp(1rem, 5vw, 3.75rem);
  }

  @media (max-width: 767px) {
    padding-inline: clamp(1rem, 5vw, 3.75rem);
  }
`;

const SectionRelated = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex: 1;
`;

const Frame51 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
`;

const RelatedVendors = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(20px, 2vw, 24px);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 100%;
  max-width: 1200px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame47 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const DealCard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  flex-wrap: wrap;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const DealCardWrapper = styled.div`
  width: 220px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GFeildsInfo = styled.img`
  width: 18px !important;
  height: 18px !important;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 4px;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding: 8px 16px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  max-width: 280px;
  width: 280px;
  backdrop-filter: blur(20px);
  background: var(--backgrounds-primary, #ffffff);
  font-family: "Montserrat", sans-serif;
  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent var(--backgrounds-primary, #ffffff)
      transparent;
  }
`;
